5<template>
	<div class="top clearfix" style="background-color: #efefef;height: 800px;">
		<div class="middle-row center" style="height: 50px;">
			<span style="font-size: 30px;">个人设置中心</span>
		</div>
		<div class="middle-row center" style="height: 746px;border-top:4px solid white;">
			<div style="height: 100%;width:100%;" class="middle-column center">
				<div style="height: 30%;width: 100%;" class="middle-row around">
					<div style="height:85%; width: 45%;background-color: white;border-radius: 10px;box-shadow: 4px 4px 6px gray;"
						class="middle-row center">
						<div style="width: 30%;height: 100%;" class="middle-row end">
							<i class="fa fa-5x fa-user-circle" style="color: orange;"></i>
						</div>
						<div style="width: 70%;height: 100%;" class="middle-column center">
							<div style="height: 40%;width: 100%;color: lightslategray" class="middle-row center">
								<span style="font-size:30px;">当前用户：<b>{{ login.username }}</b></span>
							</div>
							<div style="height: 40%;width: 100%;" class="middle-row center">
								<span style="font-size:20px;">所属街道：<b>{{ login.street }}</b></span>
							</div>
						</div>
					</div>
					<div style="height:70%;width: 3px;background-color: lightgray;"></div>
					<div class="middle-row around"
						style="height:85%; width: 45%;background-color: white;border-radius: 10px;box-shadow: 4px 4px 6px gray;">
						<button class="btn btn-success btn-lg" data-toggle="modal"
							data-target="#changePWD">修改密码</button>
						<button class="btn btn-primary btn-lg" data-toggle="modal" data-target="#editINFO">编辑信息</button>
					</div>
				</div>
				<div style="height: 70%;width: 100%;">
					<table class="table" style="box-shadow: 4px 4px 6px gray;background-color: white;">
						<caption style="font-size: 20px;text-align: left;color: black;">登录历史：共{{ logcount }}条记录<small>
								仅显示前10条登录记录</small></caption>
						<thead>
							<tr>
								<th>序号</th>
								<th>用户名</th>
								<th>登录时间</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(log, index) in logs" :key="index">
								<td>{{ index + 1 }}</td>
								<td>{{ login.username }}</td>
								<td>{{ log.loginTime }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="modal fade" id="changePWD" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
			aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
						<h4 class="modal-title" id="myModalLabel">修改密码</h4>
					</div>
					<div class="modal-body middle-column center">
						<div class="middle-column center" style="height:80%;width:80%;background-color: white;">
							<div class="form-group">
								<label for="oldpwd">请输入原密码</label><input type="email" class="form-control" id="oldpwd"
									v-model="oldpwd" />
							</div>
							<div class="form-group">
								<label for="newpwd">请输入新密码</label><input type="password" class="form-control"
									id="newpwd" v-model="newpwd1" />
							</div>
							<div class="form-group">
								<label for="newpwd2">请再次输入密码</label><input type="password" class="form-control"
									id="newpwd2" v-model="newpwd2" />
							</div>
							<button type="button" class="btn btn-success" @click="changePwd">修改密码</button>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
					</div>
				</div><!-- /.modal-content -->
			</div><!-- /.modal -->
		</div>
		<div class="modal fade" id="editINFO" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
			aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
						<h4 class="modal-title" id="myModalLabel">编辑个人信息</h4>
					</div>
					<div class="modal-body middle-column center">
						<div style="height: 200px; width: 50%;background-color: white;"
							class="middle-column between edit">
							<div class="input-group">
								<span class="input-group-addon">用户名</span>
								<input type="text" v-model="login.username" class="form-control" placeholder="用户姓名">
							</div>
							<div class="input-group">
								<span class="input-group-addon">所属街道</span>
								<select id="select" v-model="login.street" class="form-control">
									<option value="东山街道">东山街道</option>
									<option value="南黎街道">南黎街道</option>
									<option value="曲阳街道">曲阳街道</option>
									<option value="渠沟镇">渠沟镇</option>
									<option value="任圩街道">任圩街道</option>
									<option value="三堤口">三堤口</option>
									<option value="相南街道">相南街道</option>
									<option value="相山东街道">相山东街道</option>
									<option value="相山西街道">相山西街道</option>
									<option value="凤凰山经济开发区">凤凰山经济开发区</option>
								</select>
							</div>
							<div class="input-group">
								<span class="input-group-addon">用户类型</span>
								<input type="text" v-model="login.usertype" disabled class="form-control">
							</div>
							<div class="input-group">
								<button type="button" class="btn btn-success" @click="updateUser">提交修改</button>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
					</div>
				</div><!-- /.modal-content -->
			</div><!-- /.modal -->
		</div>
	</div>
</template>

<script>
import { util } from '../../static/util.js'
export default {
	data() {
		return {
			usertype: ['高级管理员', '普通管理员', '标准用户'],
			id: '',
			login: {
				id: '',
				username: '',
				password: '',
				usertype: '',
				street: ''
			},
			oldpwd: '',
			newpwd1: '',
			newpwd2: '',
			logs: [],
			logcount: '',
		}
	},
	methods: {
		updateUser: function () {
			this.$http.post(this.GLOBAL.base + 'updateLogin', this.login, {
				emulateJSON: true
			}).then(function (msg) {
				this.login = msg.body
				alert("用户信息修改成功");
				$("#editINFO").modal('hide');
			})
		},
		changePwd: function () {
			if (this.oldpwd == this.login.password) {
				if (this.newpwd1 == this.newpwd2) {
					this.login.password = this.newpwd1;
					this.$http.post(this.GLOBAL.base + 'updateLogin', this.login, {
						emulateJSON: true
					}).then(function (msg) {
						this.login = msg.body;
						this.oldpwd = '';
						this.newpwd1 = '';
						this.newpwd2 = '';
						alert("密码修改成功");
						$("#changePWD").modal('hide');
					})
				} else {
					alert("两次输入密码不对");
				}
			} else {
				alert("原密码错误，请重新输入");
			}
		}
	},
	mounted() {
		this.id = window.localStorage.getItem('_id');
		this.$http.get(this.GLOBAL.base + 'getLoginById', {
			params: {
				id: this.id
			}
		}).then(function (msg) {
			this.login = msg.body;
			this.$http.get(this.GLOBAL.base + 'getLoginLog', {
				params: {
					id: this.login.id,
					pageindex: 0,
					pagesize: 10
				}
			}).then(function (msg) {
				this.logs = msg.body;
				this.logcount = this.logs[0].logCount
				for (var log of this.logs) {
					log.loginTime = util.timeToStringWithYear(log.loginTime);
				}
			})
		});
	},
	components: {

	},
}
</script>

<style></style>
